/** A non-2xx HTTP answer from the gateway (Spring error page or filter Result). */
export class HttpError extends Error {
  constructor(
    readonly status: number,
    message: string,
    readonly body: unknown,
  ) {
    super(message);
    this.name = 'HttpError';
  }
}

/** A business failure: HTTP 200 with Result.code !== 0 (e.g. 3003 "Not allow to access certain areas"). */
export class BizError extends Error {
  constructor(
    readonly code: number,
    message: string,
    readonly data: unknown,
  ) {
    super(message);
    this.name = 'BizError';
  }
}

/** Best human-readable message for any error thrown by the API layer. */
export function errorMessage(err: unknown): string {
  if (err instanceof BizError || err instanceof HttpError) return err.message;
  if (err instanceof Error) return err.message;
  return String(err);
}
